// extracted by mini-css-extract-plugin
module.exports = {"text-field-label":"DJUsers_text-field-label__3z-fJ","left-panel":"DJUsers_left-panel__3BU3P","right-panel":"DJUsers_right-panel__1gamV"};